import MetodosGenerales from "@/utils/metodosgenerales.vue.js";

export default {
  //ObtenerTelefonos
  async Telefonos(vm) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", vm.datos.nrreporte);
    datosReporte.append("svindice", vm.datos.svindice);
    return vm.axios
      .post(
        `${vm.domain.domainNameForApi}DatosContacto/ObtenerTelefonos`,
        datosReporte
      )
      .then((response) => response.data);
  },
  async obtenerActores(vm) {
    var formData = new FormData();
    formData.append("aiclave", vm.datos.aiclave);
    formData.append("nrreporte", vm.datos.nrreporte);
    formData.append("svindice", vm.datos.svindice);
    vm.axios
      .post(
        `${vm.domain.domainNameForApi}DatosContacto/ObtenerActores`,
        formData
      )
      .then((response) => {
        vm.actores.opcionesActores = response.data;
      });
  },
  obtenerTiposTelf(vm) {
    vm.axios
      .post(`${vm.domain.domainNameForApi}DatosContacto/ObtenerTiposTelf`)
      .then((response) => {
        vm.tipotelf.opcionestipotelf = response.data;
      });
  },
  async ObtenerInformacionActor(vm, staid) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", vm.datos.nrreporte);
    datosReporte.append("svindice", vm.datos.svindice);
    datosReporte.append("staid", staid);
    datosReporte.append("uslogin", MetodosGenerales.ObtenerUserName());
    return await vm.axios
      .post(
        `${vm.domain.domainNameForApi}DatosContacto/InfoActor`,
        datosReporte
      )
      .then((response) => response.data);
  },
  async eliminarContacto(vm, item) {
    var formData = new FormData();
    formData.append("nrreporte", vm.datos.nrreporte);
    formData.append("svindice", vm.datos.svindice);
    formData.append("staid", item.staid);
    formData.append("sttid", item.sttid);
    formData.append("stid", item.stid);
    return vm.axios
      .post(
        `${vm.domain.domainNameForApi}DatosContacto/EliminarContacto`,
        formData
      )
      .then((response) => response.data);
  },
  async actualizarContacto(vm, item) {
    var formData = new FormData();
    formData.append("stid", item.stid);
    formData.append("nrreporte", vm.datos.nrreporte);
    formData.append("svindice", vm.datos.svindice);
    formData.append("staid", vm.actores.staid.staid);
    formData.append("sttid", vm.tipotelf.sttid.sttid);
    formData.append("stprefijo", vm.prefijo);
    formData.append("stnumero", vm.numtelf2);
    formData.append("stverificado", 0);
    formData.append("stpais", vm.pais);
    let response = await vm.axios.post(
      `${vm.domain.domainNameForApi}DatosContacto/ActualizarContacto`,
      formData
    );
    return response.data[0];
  },
  async altaContacto(vm) {
    var formData = new FormData();
    formData.append("nrreporte", vm.datos.nrreporte);
    formData.append("svindice", vm.datos.svindice);
    formData.append("staid", vm.actores.staid.staid);
    formData.append("sttid", vm.tipotelf.sttid.sttid);
    formData.append("stprefijo", vm.prefijo);
    formData.append("stnumero", vm.numtelf2);
    formData.append("stverificado", 0);
    formData.append("stpais", vm.pais);
    return vm.axios
      .post(`${vm.domain.domainNameForApi}DatosContacto/AltaContacto`, formData)
      .then((response) => response.data);
  },
  async insertarinfoactor(vm) {
    var formData = new FormData();
    formData.append("nrreporte", vm.datos.nrreporte);
    formData.append("svindice", vm.datos.svindice);
    formData.append("staid", vm.actores.staid.staid);
    formData.append("nombre", vm.nombre);
    formData.append("horario", vm.horario);
    return vm.axios
      .post(
        `${vm.domain.domainNameForApi}DatosContacto/AgregarInformacionActor`,
        formData
      )
      .then((response) => response.data);
  },
  async EditarInformacionActor(vm, staid) {
    var formData = new FormData();
    formData.append("nrreporte", vm.datos.nrreporte);
    formData.append("svindice", vm.datos.svindice);
    formData.append("staid", staid);
    formData.append("nombre", vm.nombre);
    formData.append("horario", vm.horario);
    return vm.axios
      .post(
        `${vm.domain.domainNameForApi}DatosContacto/EditarInformacionActor`,
        formData
      )
      .then((response) => response.data);
  },
  async CambioPosicionActores(vm, newposition) {
    var formData = new FormData();
    formData.append("nrreporte", vm.datos.nrreporte);
    formData.append("svindice", vm.datos.svindice);
    formData.append("actores", JSON.stringify([newposition]));
    return vm.axios
      .post(
        `${vm.domain.domainNameForApi}DatosContacto/CambioPosicionActores`,
        formData
      )
      .then((response) => response.data);
  },
  async CambioPosicionTelefonos(vm, orden, stid) {
    var formData = new FormData();
    formData.append("nrreporte", vm.datos.nrreporte);
    formData.append("svindice", vm.datos.svindice);
    formData.append("orden", orden);
    formData.append("stid", stid);
    formData.append("staid", vm.staid_aux);
    return vm.axios
      .post(
        `${vm.domain.domainNameForApi}DatosContacto/CambioPosicionTelefonos`,
        formData
      )
      .then((response) => response.data);
  },
  obtenerPermisoIVR(vm) {
    var permiso = new FormData();
    permiso.append("permiso", 130);
    return vm.axios
      .post(
        `${vm.domain.domainNameForApi}DatosContacto/ObtenerPermisoIVR`,
        permiso
      )
      .then((response) => response.data);
  },
  async LlamadaIVRServ(vm, telefono, actor) {
    let datos = await MetodosGenerales.obtenerSessionReporte('reporte');
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", datos.nrreporte);
    datosReporte.append("svindice", datos.svindice);
    datosReporte.append("telefono", telefono);
    datosReporte.append("actor", actor);
    datosReporte.append("uslogin", MetodosGenerales.ObtenerUserName());
    return vm.axios
      .post(`${vm.domain.domainNameForApi}DatosContacto/IVR`, datosReporte)
      .then((response) => response.data);
  },
  async ObtenerTelSinDefinir(vm) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", vm.datos.nrreporte);
    datosReporte.append("svindice", vm.datos.svindice);
    return vm.axios
      .post(
        `${vm.domain.domainNameForApi}DatosContacto/ObtenerTelSinDefinir`,
        datosReporte
      )
      .then((response) => response.data);
  },
  async ObtenerContactoInteligente(vm) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", vm.datos.nrreporte);
    datosReporte.append("svindice", vm.datos.svindice);
    return vm.axios
      .post(
        `${vm.domain.domainNameForApi}DatosContacto/ContactoInteligente`,
        datosReporte
      )
      .then((response) => {
        vm.contactoInteligente = response.data;
      });
  },

  async EliminarActor(vm, staid) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", vm.datos.nrreporte);
    datosReporte.append("svindice", vm.datos.svindice);
    datosReporte.append("staid", staid);
    return vm.axios
      .post(
        `${vm.domain.domainNameForApi}DatosContacto/EliminarActor`,
        datosReporte
      )
      .then((response) => response.data);
  },
  async ValidaFirmaElectronica(vm, data) {
    data.append("reporte", vm.datos.nrreporte);
    data.append("indice", vm.datos.svindice);
    return vm.axios
      .post(
        `${vm.domain.domainNameForApi}DatosContacto/ValidaFirmaElectronica`,
        data
      )
      .then((response) => response.data);
  },
  async ObtenerIVR_Abogado(vm, prclave) {
    var formData = new FormData();
    formData.append("prclave", prclave);
    return vm.axios
      .post(
        `${vm.domain.domainNameForApi}DatosContacto/ObtenerIVR_Abogado`,
        formData
      )
      .then((response) => response.data);
  },

  async ObtenerPermisosPerfil(vm, peclave) {
    var formData = new FormData();
    formData.append("peclave", peclave);
    return vm.axios
      .post(
        `${vm.domain.domainNameForApi}DatosContacto/ObtenerPermisosPerfil`,
        formData
      )
      .then((response) => response.data);
  },

  async ObtenerDiasConcluidos(vm) {
    var formData = new FormData();
    formData.append("nrreporte", vm.datos.nrreporte);
    formData.append("svindice", vm.datos.svindice);
    return vm.axios
      .post(
        `${vm.domain.domainNameForApi}DatosContacto/ObtenerDiasConcluidos`,
        formData
      )
      .then((response) => response.data);
  },
  async ObtenerDiasConcluidosT(vm) {
    var formData = new FormData();
    formData.append("nrreporte", vm.displayInputs.nrreporte);
    formData.append("svindice", vm.displayInputs.svindice);
    return vm.axios
      .post(
        `${vm.domain.domainNameForApi}DatosContacto/ObtenerDiasConcluidos`,
        formData
      )
      .then((response) => response.data);
  },

  async ObtenerCodigoIVR(vm) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", vm.datos.nrreporte);
    datosReporte.append("svindice", vm.datos.svindice);
    datosReporte.append("uslogin", MetodosGenerales.ObtenerUserName());

    let response = await vm.axios.post(
      `${vm.domain.domainNameForApi}DatosContacto/ObtenerCodigoIVR`,
      datosReporte
    );
    return response.data;
  },
  async EnviarSMS(vm, numero) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", vm.datos.nrreporte);
    datosReporte.append("svindice", vm.datos.svindice);
    datosReporte.append("numero", numero);
    let response = await vm.axios.post(
      `${vm.domain.domainNameForApi}DatosContacto/EnviarSMSTelDinamico`,
      datosReporte
    );
    return response.data;
  },
  async EnviarNotificacion(vm, ciid, fecha, fechaRecordatorio) {
    var datosReporte = new FormData();
    datosReporte.append("ciid", ciid);
    datosReporte.append("fecha", fecha);
    datosReporte.append("uslogin", MetodosGenerales.ObtenerUserName());
    datosReporte.append("fechaRecordatorio", fechaRecordatorio);

    let response = await vm.axios.post(
      `${vm.domain.domainNameForApi}DatosContacto/EnviarNotificacion`,
      datosReporte
    );
    return response.data;
  },
  async ObtenerPerfil(vm) {
    let response = await vm.axios.post(`${vm.domain.domainNameForApi}DatosContacto/ObtenerPerfil`);
    return response.data
  },
  async ObtenerTipoActor(vm, actor) {
    var data = new FormData();
    data.append("actor", actor);
    let response = await vm.axios.post(`${vm.domain.domainNameForApi}ReporteGeneral/ObtenerTipoActor`, data)
    return response.data
  },
  async ValidarIVR(nrreporte, svindice, IVR) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", nrreporte);
    datosReporte.append("svinidice", svindice);
    datosReporte.append("IVR", IVR);
    let response = await axios.post(`${domain.domainNameForApi}ReporteGeneral/ValidarIVR`, data)
    return response.data
  }
};
